// Manter em sincronia com apps/api/src/core/auth/permissions.ts (cópia manual).

export const PERMISSIONS = [
  'users:read',
  'users:create',
  'users:update',
  'users:delete',
  'roles:read',
  'roles:create',
  'roles:update',
  'roles:delete',
  'admin:any',
  'financeiro:read',
  'payments:read',
  'payments:update',
  'clientes:read',
  'clientes:create',
  'clientes:update',
  'clientes:delete',
  'relatorios:read',
  'relatorios:write',
  'precos:write',
  'pricing:read',
  'pricing:update',
  'submissions:read',
  'submissions:update',
  'submissions:delete',
  'whatsapp:read',
  'whatsapp:write',
  'integracoes:read',
  'integracoes:write',
  'disparos:read',
  'disparos:write',
  'campanhas:read',
  'campanhas:write',
] as const

export type Permission = (typeof PERMISSIONS)[number]

export function hasAnyPermission(
  userPerms: readonly string[] | undefined,
  required: readonly string[],
): boolean {
  if (required.length === 0) return true
  if (!userPerms || userPerms.length === 0) return false
  return required.some((p) => userPerms.includes(p))
}

export function hasAllPermissions(
  userPerms: readonly string[] | undefined,
  required: readonly string[],
): boolean {
  if (required.length === 0) return true
  if (!userPerms || userPerms.length === 0) return false
  return required.every((p) => userPerms.includes(p))
}
